import PropTypes from 'prop-types';
import React from 'react';

import Icon from './Icon';

const NUMBER_OF_ARCS = 3;

const VARIANTS = {
  default: 'wifi-thick',
  filled: 'wifi-badge-dark',
  outline: 'wifi-badge-outline',
};

const IconWiFiSignal = ({
  signalStrength = 0,
  variant = 'default',
  className = '',
}) => {
  const arcs = Math.ceil((NUMBER_OF_ARCS / 100) * signalStrength);
  const name =
    arcs === NUMBER_OF_ARCS
      ? VARIANTS[variant]
      : `${VARIANTS[variant]}-${arcs}`;

  return <Icon className={className} name={name} role="status" />;
};

IconWiFiSignal.propTypes = {
  signalStrength: PropTypes.number,
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
  className: PropTypes.string,
};

export default IconWiFiSignal;
